<form id="permanent_planning_duplicate" [formGroup]="this.permanentPlanningDuplicateForm" (ngSubmit)="this.duplicate()">
    
    <div class="title_card">{{'DUPLICATE_PLANNING' | translate}}</div>   
    
    <div id="permanent_planning_duplicate_form">
        
        <marv-section-title label="{{'SOURCE' | translate}}"/>
        <marv-select label="{{ 'WEEK_TO_COPY' | translate }}" icon="calendar-outline" formName="srcWeek" [items]="this.weeksToCopyItems"></marv-select>
        <marv-select label="{{ 'AGENTS' | translate }}" icon="person-outline" formName="agentsId" [items]="this.agentsItems" [multiple]="true"></marv-select>
        <marv-select label="{{ 'DAYS' | translate }}" icon="calendar-outline" formName="days" [items]="this.daysItems" [multiple]="true"></marv-select>
        <marv-toggle label="{{'COPY_EVENTS' | translate}}" formName=copyEvents labelPlacement="end" />
        
        <marv-section-title label="{{'DESTINATION' | translate}}"/>
        <marv-select label="{{ 'DESTINATION_WEEKS' | translate }}" icon="calendar-outline" formName="destWeeks" [items]="this.destinationWeeks" [multiple]="true"></marv-select>
    </div>
    
    <ion-grid id="footer_permanent_planning_duplicate">
        <ion-row class="ion-justify-content-around">
            <ion-col size="auto">
                <marv-button type="submit" label="{{ 'DUPLICATE' | translate }}" icon="checkmark-outline" color="primary" [isFetching]="this.isFetchingSave"/>
            </ion-col>
            <ion-col size="auto">
                <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancel()" />
            </ion-col>
        </ion-row>
    </ion-grid>
    
</form>